import { atom } from 'jotai'
import type { TCountry } from '../types'

export const countryState = atom<TCountry>({
    country: '',
    roman_name: '',
    native_name: '',
    test: '',
    live: '',
    short: '',
    shorter: '',
    maintenance_mode: {
        maintenance_mode: false
    },
    flagUrl: '',
    config: {
        currency: {
            code: '',
            name: ''
        },
        languageSettings: {
            default: '',
            items: []
        }
    },
    payment_options: []
})
